//Code der mit dem ersten Aufruf der Seite auf dem Client ausgeführt wird, und bei navigationen etc. nicht erneut

import { getVapid, request } from './api.js'
import { useAuth } from '../composables/useAuth'
import { watch } from 'vue'

/**
 * Sende Push Registrierungsdaten an den Server
 * body: Objekt von Javascript Notification API
 */
export async function savePushRegistration(body) {
  const data = await request(`/users/notification`, {method: 'POST', body: JSON.stringify(body),})
  return data?.message ?? null;
}

window.needPermissionNotification = false
const checkNotificationPermission = () => {
  try {
    if (typeof window === 'undefined') return
      if (!('Notification' in window)) {
      return window.needPermissionNotification = false
    }
    const permission = Notification.permission
    if (permission === 'default') window.needPermissionNotification = true
    else window.needPermissionNotification = false
  } catch (e) {
    window.needPermissionNotification = false
  }
}

let clickListenerInstalled = false
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = atob(base64)
  const outputArray = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i)
  return outputArray
}
export async function ensurePushPermissionAndSubscription(vapidPublicKey) {
  if (typeof window === 'undefined') return null;
  if (!('Notification' in window) || !('serviceWorker' in navigator)) return null;
  const registerIfNeeded = async () => {
    const swRegistration = await navigator.serviceWorker.ready
    const existingSubscription = await swRegistration.pushManager.getSubscription()
    if (existingSubscription) return existingSubscription
    const permission = Notification.permission
    if (permission !== 'granted') {
      const result = await Notification.requestPermission();
      if (result !== 'granted') return null;
    }
    return await swRegistration.pushManager.subscribe({userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)});
  }
  const permission = Notification.permission;
  console.log("P:", permission);
  if (permission === 'granted') return await registerIfNeeded()
  if (permission === 'denied') return null;
  if (!clickListenerInstalled) {
    clickListenerInstalled = true;
    const onNextClick = async () => {
      console.log("Klick erkannt!");
      document.removeEventListener('click', onNextClick, true)
      clickListenerInstalled = false;
      try {
        await registerIfNeeded();
      } catch (error) {
        console.error('Push-Registrierung fehlgeschlagen:', error)
      }
    }
    console.log("Wait for Click...");
    document.addEventListener('click', onNextClick, { once: true, capture: true })
  }
  return null;
}

export async function start() { //soll absichtlich nicht blockieren sondern im Hintergrund laufen
    if ('serviceWorker' in navigator) window.addEventListener('load', async () => {
        try {
            const reg = await navigator.serviceWorker.register('/sw.js')
            console.log('Wetter-Wetter Service Worker registriert:', reg)
        } catch (err) {
            console.error('SW Registrierung fehlgeschlagen:', err)
        }
    })

    const vapid = await getVapid();

    if(!vapid?.answer?.publicKey) return;
    checkNotificationPermission();

    const auth = useAuth();

    watch(() => auth.user.value, async (user) => {
        if(user) {
            console.log("Benutzer anmeldung erkannt!", vapid.answer.publicKey);
            const pushPromise = ensurePushPermissionAndSubscription(vapid.answer.publicKey);
            console.log("Push Registriert:", pushPromise);
            console.log("Push promise:", await pushPromise);

            pushPromise.then(push => savePushRegistration(push));
        }
    }, { immediate: true });
}